import type { FC } from 'react'

import { Avatar, Box, Flex, HStack, Text } from '@chakra-ui/react'
import StarIcon from '@components/icons/star-icon'
import { useStore } from '@contexts/store'
import { Sanitized } from '@helper/globalHelpers'
import dayjs from 'dayjs'
import { BsReplyFill } from 'react-icons/bs'

interface ReviewProps {
  item: any
  className?: string
}

const ReviewCard: FC<ReviewProps> = ({ item, className = '' }) => {
  const { storeData } = useStore()
  const { fullName, created } = item
  
  return (
    <Box>
      <Flex justify="space-between" mb="3" align="center">
        <HStack spacing="2" align="center">
          <Avatar name={fullName?.split(' ')[0]} size="md" fontWeight="600" />
          <Text as="span" fontWeight="600">
            {fullName}
          </Text>
        </HStack>
        <Text as="span" fontSize="14px" color="#8C98A4">
          {dayjs(created).format('MMMM D, YYYY')}
        </Text>
      </Flex>
      <Box mt="3" className="flex space-s-1 mb-3.5">
        {[...Array(5)].map((_, idx) => (
          <StarIcon
            key={idx}
            color={idx < item.rate ? '#F5CA99' : '#DFE6ED'}
            className="w-3.5 lg:w-4 h-3.5 lg:h-4"
          />
        ))}
      </Box>
      <Text className="xl:leading-[2em]" color="elegantGrayText">
        {item?.comment}
      </Text>
      {item?.reply && (
        <Flex
          my="6"
          direction="column"
          borderRadius="4px"
          p="4"
          bg="inputFieldOutline"
        >
          <HStack spacing="2.5">
            <Box as={BsReplyFill} transform="rotate(180deg)" size="24px"/>
            <Text fontWeight="700" fontSize="12px">
              Response from{' '}
              <Text as="span" fontWeight="600">
                {storeData?.name}
              </Text>
            </Text>
          </HStack>
          <Box
            mt="3"
            sx={{
              '& *': {
                fontSize: '14px',
              },
            }}
          >
            <Sanitized html={item?.reply} />
          </Box>
        </Flex>
      )}
    </Box>
  )
}

export default ReviewCard
